import { useQuery } from 'react-query';
import dayjs from 'dayjs';

import type { IGetLeadsResponse } from 'src/services/api/leads/use-leads';
import { apiClient } from 'src/services/api/client';
import type { ILead } from 'src/services/api/leads/types';
import { queryKeys } from 'src/services/api/constants';
import { getAnalyticsWindowStart } from 'src/pages/landlord/analytics/utils/get-analytics-window-start';

type SelectFnType = (data: ILead[]) => any;

type Params = {
    from?: string;
    to?: string;
    propertyLabels?: string[];
    includeArchived?: boolean;
};

export const useAnalyticsLeads = (select?: SelectFnType, params?: Params) => {
    const from = params?.from ?? getAnalyticsWindowStart().toISOString();
    const to = params?.to ?? dayjs().endOf('day').toISOString();
    const propertyLabels = params?.propertyLabels ?? [];
    const includeArchived = params?.includeArchived ?? false;

    return useQuery(
        [queryKeys.analyticsLeads, from, to, [...propertyLabels].sort(), includeArchived],
        async () => {
            const searchParams = new URLSearchParams();
            searchParams.set('from', from);
            searchParams.set('to', to);
            for (const label of propertyLabels) {
                searchParams.append('property_labels', label);
            }
            if (includeArchived) {
                searchParams.set('include_archived', 'true');
            }
            const res = await apiClient('api/landlord/analytics/leads', { searchParams })
                .json<IGetLeadsResponse>();
            return res.leads;
        }, {
            onError: (error) => {
                console.error(error);
            },
            select,
        }
    );
};
